<template>
  <div class="el-loading flex center" v-show="visible">
    <a-spin size="large" :tip="text || '加载中'"></a-spin>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        visible: false,
        text: '',
      }
    },
  }
</script>

<style scoped>
  .el-loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.6);
    z-index: 9999;
  }
</style>
